import { events as eventTypes } from '../../../proto/protobuf';
import { SearchboxSourceType } from '../../../state/searches/types';

import { loadProtobuf } from './lazyExports';

type GetProtobufSearchSource = (
  searchboxSource: SearchboxSourceType
) => Promise<eventTypes.SearchBeginV1.SearchboxSource>;
export const getProtobufSearchSource: GetProtobufSearchSource = async (searchboxSource: SearchboxSourceType) => {
  const { events } = await loadProtobuf();

  const protoSearchboxSources = events.SearchBeginV1.SearchboxSource;

  switch (searchboxSource) {
    case SearchboxSourceType.MsTeamsSearch:
      return protoSearchboxSources.MS_TEAMS_SEARCH;
    case SearchboxSourceType.Publisher:
      return protoSearchboxSources.PUBLISHER;
    case SearchboxSourceType.MainSearch:
      return protoSearchboxSources.MAIN_SEARCH;
    case SearchboxSourceType.DiscoverTopics:
      return protoSearchboxSources.DISCOVER_TOPICS;
    case SearchboxSourceType.SerpSessionEnforcement:
    default:
      return protoSearchboxSources.SERP_SESSION_ENFORCEMENT;
  }
};
